import {UI} from "../../../stem-core/src/ui/UIBase";

import {FlowController} from "./FlowController";
import {Messages} from "../../Messages";
import {iFrameState} from "../../services/IFrameState";
import {Money} from "../../../client/state/misc/Money";
import {BlinkLogo} from "../../../core/ui/SVGElements.jsx";
import {isThirdPartyStorageBlocked} from "../../Utils";
import {iFrameConnection} from "../../services/IFrameConnection";
import {IFrameMessages} from "../../../blink-sdk/messaging/IFrameMessages";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {authService} from "../../../client/connection/Services";
import {AuthToken} from "../../../client/connection/AuthToken";


export class PaywallPurchaseFlowController extends FlowController {
    actionButtonTestId = "readForWithBlinkButton";
    actionButtonDefaultAnid = "purchase-button";

    processPaymentRequest() {
        const paymentDetails = this.constructor.getPaymentDetails();

        // Users with third party storage blocked will have a slightly different user experience, meaning that
        // they will be asked to manually make the content payment when they authenticate from the wall iframe.
        if (isThirdPartyStorageBlocked()) {
            iFrameConnection.sendToIFrames(IFrameMessages.MAKE_NEXT_PAYMENT_MANUALLY,
                {offerId: paymentDetails.offerId});
        }

        iFrameConnection.sendToSDK(IFrameMessages.MAKE_PAYMENT_VIA_SDK, {
            request: paymentDetails
        });
    }

    onClickAuthenticated() {
        this.processPaymentRequest();
    }

    onClickNotAuthenticated() {
        super.onClickNotAuthenticated();
        const listener = this.attachListener(authService, AuthToken.EventTypes.LOGIN, () => {
            listener.remove();
            this.processPaymentRequest();
        });
    }

    static getPaymentDetails() {
        const currency = iFrameState.getPaymentDetailsCurrency();
        let {paymentDetails} = iFrameState;
        // TODO @branch are these fields used anywhere?????
        if (paymentDetails.amountInSubunits != null) {
            paymentDetails.amount = currency.subunitsToAmount(paymentDetails.amountInSubunits);
        }
        if (paymentDetails.amountInMainUnits != null) {
            paymentDetails.amount = currency.mainUnitsToAmount(paymentDetails.amountInMainUnits);
        }
        return paymentDetails;
    }

    getArticlePriceAmount() {
        const currency = iFrameState.getPaymentDetailsCurrency();
        return new Money(this.constructor.getPaymentDetails().amount, currency);
    }

    getBlinkLogo() {
        return <BlinkLogo
            size={14}
            style={{
                padding: 0,
                transform: "translateY(-2px)",
                marginLeft: 2,
                display: "inline-block"
            }}/>;
    }

    getDefaultButtonLabel() {
        return [Messages.readForWith(this.getArticlePriceAmount()), this.getBlinkLogo()];
    }

    getHeaderDefaultText() {
        return super.getHeaderDefaultText() || Messages.paywallTopMessage(iFrameMerchantService.getMerchant().name);
    }

    getActionButtonDefaultLabel() {
        return super.getActionButtonDefaultLabel() || this.getDefaultButtonLabel();
    }

    getLoginFooterMessage() {
        return Messages.alreadyPurchased;
    }
}
